import { render, staticRenderFns } from "./standardsectionedit.vue?vue&type=template&id=74c757ca&scoped=true"
import script from "./standardsectionedit.vue?vue&type=script&lang=js"
export * from "./standardsectionedit.vue?vue&type=script&lang=js"
import style0 from "./standardsectionedit.vue?vue&type=style&index=0&id=74c757ca&prod&scoped=scoped&lang=css"
import style1 from "./standardsectionedit.vue?vue&type=style&index=1&id=74c757ca&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c757ca",
  null
  
)

export default component.exports